import React, { Fragment } from 'react';

const Benefits = () => (
  <Fragment>
    <ul>
      <li>Book with flexibility at low daily and hourly rates</li>
      <li>Pay only when you choose to drive</li>
      <li>
        Access a large fleet of well-maintained EVs at your convenience,
        24/7, 365 days a year
      </li>
      <li>
        Contribute to a more environmentally sustainable transportation
        ecosystem
      </li>
      <li>
        Avoid additional expenses of owning and maintaining your own
        vehicle
      </li>
    </ul>
    <br />
  </Fragment>
);

export default Benefits;



// WEBPACK FOOTER //
// ./src/components/Static/DriverFaq/General/Benefits.js